import { Footer, Container, Row, Col } from 'darrius';

import {
  ProfileHeroSection,
  ProfileRating,
  ProfileRecomendations,
  ProfileExpertises,
  ProfileBadges,
  ProfileAbout,
} from './partials';

import { Header } from '../../components/atoms';
import { HeadContent, ProfileMenu } from '../../components';

import styles from './InternalProfileTemplate.module.scss';

import { IProfileTemplateProps } from './@interface';
import { useEffect } from 'react';
import { triggerEvent } from '../../utils/triggerEvent';

export default function InternalProfileTemplate({
  profilePageProps,
  staticContent,
  isInstantMatch = false,
  requestId = null,
  isUserCliAuthenticated = false,
  noindex = false,
}: IProfileTemplateProps) {
  const {
    meta,
    mainSection,
    categorySlug,
    user,
    resume,
    services,
    menu,
    rating,
    recomendations,
    badges,
    isSentMessage,
    internalProfileId,
    requestUuid,
    slug,
  } = profilePageProps;

  const { footerContent } = staticContent;

  const heroSectionData = {
    user,
    requestId,
    mainSection,
    rating,
    isSentMessage,
    resume,
    requestUuid,
    slug,
  };

  const pageType = isInstantMatch
    ? 'instant-contact-profile:show'
    : 'profiles:internal';

  useEffect(() => {
    const trackingTimeout = setTimeout(() => {
      if (isInstantMatch && !!requestId && !!user.id) {
        triggerEvent('instant-match_service-sale__inicialization', {
          requestId: requestId,
          profileId: user.id,
        });
      }

      if (!isInstantMatch && !!internalProfileId) {
        triggerEvent('internal_profile__inicialization', {
          profileId: internalProfileId,
        });
      }
    }, 1000);

    return () => clearTimeout(trackingTimeout);
  }, [internalProfileId, user, requestId]);

  return (
    <>
      <HeadContent
        metaTitle={meta.title}
        slug={categorySlug}
        metaDescription={meta.description}
        type={pageType}
        noindex={noindex}
      />
      <Header.Simple />
      <main
        className={`profile-page-internal ${styles['profile-page']} ${styles.internal}`}
        data-category-slug={categorySlug}
      >
        <ProfileHeroSection
          heroSectionData={heroSectionData}
          isInstantMatch={isInstantMatch}
          isUserCliAuthenticated={isUserCliAuthenticated}
        />

        <ProfileMenu
          menu={menu}
          user={user}
          internalProfileId={internalProfileId}
        />

        <Container className="page-content space-top space-bottom">
          <Row>
            <Col className={`col-sm-12 col-md-6`}>
              {user.partner?.isPartnerProfile && (
                <Row>
                  <Col>
                    <div className={styles['partner-profile-highlights']}>
                      <img
                        alt="Ícone de empresa parceira"
                        src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/highlight-image.svg`}
                        width={24}
                        height={24}
                      />
                      <div>
                        <p
                          className={
                            styles['partner-profile-highlights__title']
                          }
                        >
                          Essa é uma empresa especialista
                        </p>
                        <p
                          className={styles['partner-profile-highlights__text']}
                        >
                          Através de uma parceria com o Getninjas, a{' '}
                          <strong>{user.name}</strong> oferece profissionais
                          especializados para atenderem o seu pedido.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
              <ProfileAbout about={resume} />
              <hr className={`${styles['soft-line']}`} />
              <ProfileBadges badges={badges} />
              <hr className={`${styles['soft-line']}`} />
              <ProfileExpertises expertises={services} />
              <hr className={`${styles['soft-line']}`} />
              <ProfileRating rating={rating} />
              <ProfileRecomendations
                recomendations={recomendations}
                rating={rating}
              />
            </Col>
          </Row>
        </Container>
      </main>
      <Footer data={footerContent} />
    </>
  );
}
